module.exports = __webpack_public_path__ + "static/media/renealtena.bf3e550c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/renealtena.webp
// module id = 739
// module chunks = 0